import { useState } from 'react'

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  })

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    // Here you would typically send the form data to your backend
    console.log('Form submitted:', formData)
    alert('¡Gracias por tu mensaje! Te responderemos pronto.')
    setFormData({ name: '', email: '', subject: '', message: '' })
  }

  return (
    <section id="contact" className="section section-alt">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>Contacto</h2>
          <p style={{ maxWidth: '800px', margin: '0 auto' }}>
            ¿Tienes preguntas sobre nuestras aplicaciones? Nuestro equipo de Vortex Software está aquí para ayudarte.
          </p>
        </div>

        <div className="grid grid-2" style={{ alignItems: 'start', gap: 'var(--spacing-3xl)' }}>
          {/* Contact Info */}
          <div>
            <h3 style={{ marginBottom: 'var(--spacing-xl)' }}>
              Información de contacto
            </h3>

            <div style={{ marginBottom: 'var(--spacing-xl)' }}>
              <h4 style={{ marginBottom: 'var(--spacing-md)' }}>Soporte técnico</h4>
              <p style={{ marginBottom: 'var(--spacing-sm)' }}>
                <strong>Email:</strong>
                <a href="mailto:centralvortexapk@gmail.com" style={{ marginLeft: 'var(--spacing-sm)' }}>
                  centralvortexapk@gmail.com
                </a>
              </p>
              <p style={{ marginBottom: 'var(--spacing-sm)' }}>
                <strong>Horario:</strong> Lunes a Viernes, 8:00 AM - 5:00 PM
              </p>
              <p style={{ marginBottom: 'var(--spacing-sm)' }}>
                <strong>Tiempo de respuesta:</strong> 24 horas
              </p>
            </div>

            <div style={{ marginBottom: 'var(--spacing-xl)' }}>
              <h4 style={{ marginBottom: 'var(--spacing-md)' }}>Preguntas frecuentes</h4>
              <div style={{
                background: 'var(--bg-tertiary)',
                borderRadius: 'var(--radius-md)',
                padding: 'var(--spacing-lg)',
                border: '1px solid var(--border)'
              }}>
                <details style={{ marginBottom: 'var(--spacing-md)' }}>
                  <summary style={{
                    cursor: 'pointer',
                    fontWeight: '600',
                    color: 'var(--text-primary)'
                  }}>
                    ¿Cuáles aplicaciones son gratuitas?
                  </summary>
                  <p style={{
                    marginTop: 'var(--spacing-sm)',
                    color: 'var(--text-secondary)',
                    fontSize: '0.9rem',
                    textAlign: 'justify'
                  }}>
                    La mayoría de nuestras aplicaciones son completamente gratuitas: Scout Conecta, Vortex Texto-Audio, Vortex Audio-Texto IA, Flashcard Vortex, Ascensos App Lite y Cuentos que Enseñan. Solo Ascensos App Vortex requiere una licencia premium debido a sus avanzadas herramientas de IA.
                  </p>
                </details>

                <details style={{ marginBottom: 'var(--spacing-md)' }}>
                  <summary style={{
                    cursor: 'pointer',
                    fontWeight: '600',
                    color: 'var(--text-primary)'
                  }}>
                    ¿Mis datos están seguros?
                  </summary>
                  <p style={{
                    marginTop: 'var(--spacing-sm)',
                    color: 'var(--text-secondary)',
                    fontSize: '0.9rem',
                    textAlign: 'justify'
                  }}>
                    Absolutamente, la privacidad es nuestra prioridad. Los datos de registro son solo para control estadístico. La información que subas para usar las herramientas nunca llega a nuestros servidores - todo se procesa localmente en tu dispositivo. Nunca compartimos tu información personal con terceros.
                  </p>
                </details>

                <details style={{ marginBottom: 'var(--spacing-md)' }}>
                  <summary style={{
                    cursor: 'pointer',
                    fontWeight: '600',
                    color: 'var(--text-primary)'
                  }}>
                    ¿Cuándo estará disponible para iOS?
                  </summary>
                  <p style={{
                    marginTop: 'var(--spacing-sm)',
                    color: 'var(--text-secondary)',
                    fontSize: '0.9rem',
                    textAlign: 'justify'
                  }}>
                    Estamos trabajando activamente en las versiones para iOS. Esperamos lanzarlas en los próximos meses, probablemente para principios del 2026. ¡Regístrate en nuestro formulario de contacto para recibir notificaciones cuando estén disponibles!
                  </p>
                </details>

                <details>
                  <summary style={{
                    cursor: 'pointer',
                    fontWeight: '600',
                    color: 'var(--text-primary)'
                  }}>
                    ¿Cómo puedo obtener soporte técnico?
                  </summary>
                  <p style={{
                    marginTop: 'var(--spacing-sm)',
                    color: 'var(--text-secondary)',
                    fontSize: '0.9rem',
                    textAlign: 'justify'
                  }}>
                    Nuestro equipo de soporte está disponible de lunes a viernes de 8:00 AM a 5:00 PM. Puedes contactarnos por email a centralvortexapk@gmail.com o usar el formulario de contacto en esta página. Nuestro tiempo de respuesta es de 24 horas máximo.
                  </p>
                </details>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <h3 style={{ marginBottom: 'var(--spacing-xl)' }}>
              Envíanos un mensaje
            </h3>

            <form onSubmit={handleSubmit} style={{
              background: 'var(--bg-tertiary)',
              borderRadius: 'var(--radius-lg)',
              padding: 'var(--spacing-xl)',
              border: '1px solid var(--border)'
            }}>
              <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                <label htmlFor="name" style={{
                  display: 'block',
                  marginBottom: 'var(--spacing-sm)',
                  fontWeight: '600',
                  color: 'var(--text-primary)'
                }}>
                  Nombre completo *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: 'var(--spacing-md)',
                    borderRadius: 'var(--radius-md)',
                    border: '1px solid var(--border)',
                    background: 'var(--bg-secondary)',
                    color: 'var(--text-primary)',
                    fontSize: '1rem'
                  }}
                />
              </div>

              <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                <label htmlFor="email" style={{
                  display: 'block',
                  marginBottom: 'var(--spacing-sm)',
                  fontWeight: '600',
                  color: 'var(--text-primary)'
                }}>
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: 'var(--spacing-md)',
                    borderRadius: 'var(--radius-md)',
                    border: '1px solid var(--border)',
                    background: 'var(--bg-secondary)',
                    color: 'var(--text-primary)',
                    fontSize: '1rem'
                  }}
                />
              </div>

              <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                <label htmlFor="subject" style={{
                  display: 'block',
                  marginBottom: 'var(--spacing-sm)',
                  fontWeight: '600',
                  color: 'var(--text-primary)'
                }}>
                  Asunto *
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: 'var(--spacing-md)',
                    borderRadius: 'var(--radius-md)',
                    border: '1px solid var(--border)',
                    background: 'var(--bg-secondary)',
                    color: 'var(--text-primary)',
                    fontSize: '1rem'
                  }}
                />
              </div>

              <div style={{ marginBottom: 'var(--spacing-xl)' }}>
                <label htmlFor="message" style={{
                  display: 'block',
                  marginBottom: 'var(--spacing-sm)',
                  fontWeight: '600',
                  color: 'var(--text-primary)'
                }}>
                  Mensaje *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  style={{
                    width: '100%',
                    padding: 'var(--spacing-md)',
                    borderRadius: 'var(--radius-md)',
                    border: '1px solid var(--border)',
                    background: 'var(--bg-secondary)',
                    color: 'var(--text-primary)',
                    fontSize: '1rem',
                    resize: 'vertical'
                  }}
                />
              </div>

              <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
                Enviar mensaje
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
} 